import { useMutation, useQueryClient } from '@tanstack/react-query';

import { inclusionsQueryKeys } from './inclusionsQueryKeys';
import { savePackageInclusionChanges } from './packageInclusionMutationUtils';

export function useUpdatePackageInclusions() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: savePackageInclusionChanges,
    onSuccess: (_data, variables) =>
      queryClient.invalidateQueries({ queryKey: inclusionsQueryKeys.packageInclusionsByOffer(variables.offerId) }),
  });
}
